<template>
  <div class="auction-management">
    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="群昵称">
          <el-input v-model="searchForm.groupNickname" placeholder="请输入群昵称" clearable style="width: 160px;"></el-input>
        </el-form-item>
        <el-form-item label="卡来源">
          <el-select v-model="searchForm.cardSource" placeholder="请选择" clearable style="width: 130px;">
            <el-option label="邮寄" :value="1"></el-option>
            <el-option label="众筹" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上拍方式">
          <el-select v-model="searchForm.auctionMethod" placeholder="请选择" clearable style="width: 130px;">
            <el-option label="竞价" :value="1"></el-option>
            <el-option label="议价" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上架代码">
          <el-input v-model="searchForm.listingCode" placeholder="请输入" clearable style="width: 140px;"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="searchForm.phone" placeholder="请输入" clearable style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="上架日期">
          <el-date-picker
            v-model="searchForm.listingDate"
            type="date"
            placeholder="选择日期"
            format="yyyy/MM/dd"
            value-format="yyyy/MM/dd"
            clearable
            style="width: 150px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
          <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
          <el-button type="success" @click="handleAdd" icon="el-icon-plus">新增上拍</el-button>
          <el-button type="warning" @click="handleDownloadTemplate" icon="el-icon-download">下载模板</el-button>
          <el-button type="info" @click="triggerImport" icon="el-icon-upload2">导入</el-button>
          <el-button type="primary" @click="handleStats" icon="el-icon-data-analysis">统计</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据列表 -->
    <el-card class="table-card">
      <div slot="header" class="clearfix">
        <span>上拍记录列表</span>
        <span style="float: right; color: #909399; font-size: 12px;">
          共 {{ pagination.total }} 条记录
        </span>
      </div>

      <el-table :data="tableData" border stripe v-loading="tableLoading">
        <el-table-column prop="id" label="ID" width="70"></el-table-column>
        <el-table-column prop="userName" label="所属用户" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="groupNickname" label="群昵称" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="cardSourceName" label="卡来源" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.cardSource === 1 ? 'warning' : 'primary'" size="small">
              {{ scope.row.cardSourceName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="listingCode" label="上架代码" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.listingCode || '-' }}</template>
        </el-table-column>
        <el-table-column prop="auctionMethodName" label="上拍方式" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.auctionMethod === 1 ? 'success' : 'info'" size="small">
              {{ scope.row.auctionMethodName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="orderCount" label="订单数量" width="90" align="center"></el-table-column>
        <el-table-column prop="listingDate" label="上架日期" width="120"></el-table-column>
        <el-table-column prop="listingDays" label="上架天数" width="90" align="center"></el-table-column>
        <el-table-column prop="cutoffDate" label="截标日期" width="120"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170">
          <template slot-scope="scope">{{ formatDate(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handlePageChange"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="total, prev, pager, next"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 新增 / 编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="680px"
      @close="handleDialogClose"
    >
      <el-form :model="form" :rules="formRules" ref="formRef" label-width="110px">
        <!-- 用户选择 -->
        <el-form-item label="所属用户" prop="userId">
          <el-select
            v-model="form.userId"
            filterable
            placeholder="请搜索并选择用户"
            style="width: 100%;"
            :disabled="isEdit"
          >
            <el-option
              v-for="u in userList"
              :key="u.id"
              :label="u.displayName"
              :value="u.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 群昵称（随所选用户自动带出，只读） -->
        <el-form-item label="群昵称">
          <span class="readonly-tip">{{ displayGroupNickname }}</span>
        </el-form-item>

        <!-- 卡来源 & 上拍方式 -->
        <el-form-item label="卡来源" prop="cardSource">
          <el-radio-group v-model="form.cardSource">
            <el-radio :label="1">邮寄</el-radio>
            <el-radio :label="2">众筹</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 上架代码 -->
        <el-form-item label="上架代码" prop="listingCode">
          <el-input v-model="form.listingCode" placeholder="请输入上架代码" maxlength="64"></el-input>
        </el-form-item>

        <!-- 上拍方式 -->
        <el-form-item label="上拍方式" prop="auctionMethod">
          <el-radio-group v-model="form.auctionMethod">
            <el-radio :label="1">竞价</el-radio>
            <el-radio :label="2">议价</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 订单数量 -->
        <el-form-item label="订单数量" prop="orderCount">
          <el-input-number v-model="form.orderCount" :min="1" :max="99999" controls-position="right"></el-input-number>
        </el-form-item>

        <!-- 上架日期 & 上架天数 -->
        <el-form-item label="上架日期" prop="listingDate">
          <el-date-picker
            v-model="form.listingDate"
            type="date"
            placeholder="选择上架日期"
            format="yyyy/MM/dd"
            value-format="yyyy/MM/dd"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="上架天数" prop="listingDays">
          <el-input-number v-model="form.listingDays" :min="1" :max="365" controls-position="right"></el-input-number>
          <span style="margin-left: 8px; color: #909399; font-size: 12px;">天</span>
        </el-form-item>

        <!-- 截标日期 -->
        <el-form-item label="截标日期" prop="cutoffDate">
          <el-date-picker
            v-model="form.cutoffDate"
            type="date"
            placeholder="选择截标日期"
            format="yyyy/MM/dd"
            value-format="yyyy/MM/dd"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>

        <!-- 备注 -->
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注（选填）" maxlength="500" show-word-limit></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看详情对话框 -->
    <el-dialog title="上拍详情" :visible.sync="viewDialogVisible" width="700px">
      <el-descriptions :column="2" border v-if="viewData">
        <el-descriptions-item label="ID">{{ viewData.id }}</el-descriptions-item>
        <el-descriptions-item label="所属用户">{{ viewData.userName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="群昵称">{{ viewData.groupNickname }}</el-descriptions-item>
        <el-descriptions-item label="卡来源">
          <el-tag :type="viewData.cardSource === 1 ? 'warning' : 'primary'" size="small">
            {{ viewData.cardSourceName }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="上架代码">{{ viewData.listingCode || '-' }}</el-descriptions-item>
        <el-descriptions-item label="上拍方式">
          <el-tag :type="viewData.auctionMethod === 1 ? 'success' : 'info'" size="small">
            {{ viewData.auctionMethodName }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="订单数量" :span="2">{{ viewData.orderCount }}</el-descriptions-item>
        <el-descriptions-item label="上架日期">{{ viewData.listingDate }}</el-descriptions-item>
        <el-descriptions-item label="上架天数">{{ viewData.listingDays }} 天</el-descriptions-item>
        <el-descriptions-item label="截标日期">{{ viewData.cutoffDate }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ viewData.remark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatDate(viewData.createTime) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ formatDate(viewData.updateTime) }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button type="primary" @click="viewDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 统计对话框 -->
    <el-dialog title="上拍统计" :visible.sync="statsDialogVisible" width="800px" @close="handleStatsDialogClose">
      <div class="stats-search">
        <el-form :inline="true" :model="statsForm" size="small">
          <el-form-item label="上架代码">
            <el-input v-model="statsForm.listingCode" placeholder="请输入" clearable style="width: 140px;"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="statsForm.phone" placeholder="请输入" clearable style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="上架日期">
            <el-date-picker
              v-model="statsForm.listingDate"
              type="date"
              placeholder="选择日期"
              format="yyyy/MM/dd"
              value-format="yyyy/MM/dd"
              clearable
              style="width: 150px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleStatsQuery" :loading="statsLoading">查询</el-button>
            <el-button @click="handleStatsReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 统计表格 -->
      <el-table
        :data="statsRows"
        border
        stripe
        v-loading="statsLoading"
        :height="320"
        style="margin-top: 12px;">
        <el-table-column prop="nickname" label="群昵称" min-width="120" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="phone" label="手机号" width="140" align="center"></el-table-column>
        <el-table-column prop="listingDate" label="上架日期" width="120" align="center"></el-table-column>
        <el-table-column prop="recordCount" label="上拍记录数" width="120" align="center"></el-table-column>
        <el-table-column prop="orderSum" label="订单数量" width="120" align="center"></el-table-column>
      </el-table>

      <!-- 合计行 -->
      <div class="stats-totals" v-if="statsData && statsData.totals">
        <span>上拍记录数合计：<strong>{{ statsData.totals.recordCount }}</strong> 条</span>
        <span style="margin-left: 32px;">订单数量合计：<strong>{{ statsData.totals.orderSum }}</strong> 单</span>
      </div>

      <!-- 分页 -->
      <el-pagination
        v-if="statsData && statsData.total > 0"
        @current-change="handleStatsPageChange"
        :current-page="statsPagination.pageNum"
        :page-size="statsPagination.pageSize"
        :total="statsData.total || 0"
        layout="total, prev, pager, next"
        style="margin-top: 8px; text-align: right;">
      </el-pagination>

      <div slot="footer">
        <el-button type="primary" @click="statsDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 隐藏的文件上传input -->
    <input
      type="file"
      ref="importFileInput"
      accept=".xlsx,.xls"
      style="display: none;"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import {
  getAuctionList, getAuction, addAuction, updateAuction, deleteAuction, getAuctionUsers,
  importAuction, downloadAuctionTemplate, getAuctionStats
} from '@/api'

export default {
  name: 'AuctionManagement',
  data() {
    return {
      searchForm: {
        groupNickname: '',
        cardSource: null,
        auctionMethod: null,
        listingCode: '',
        listingDate: '',
        phone: ''
      },
      tableData: [],
      tableLoading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增上拍',
      isEdit: false,
      submitLoading: false,
      form: {
        id: null,
        userId: null,
        cardSource: 1,
        listingCode: '',
        auctionMethod: 1,
        orderCount: 1,
        listingDate: '',
        listingDays: 7,
        cutoffDate: '',
        remark: ''
      },
      formRules: {
        userId: [{ required: true, message: '请选择所属用户', trigger: 'change' }],
        cardSource: [{ required: true, message: '请选择卡来源', trigger: 'change' }],
        auctionMethod: [{ required: true, message: '请选择上拍方式', trigger: 'change' }],
        orderCount: [{ required: true, message: '请输入订单数量', trigger: 'blur' }],
        listingDate: [{ required: true, message: '请选择上架日期', trigger: 'change' }],
        listingDays: [{ required: true, message: '请输入上架天数', trigger: 'blur' }],
        cutoffDate: [{ required: true, message: '请选择截标日期', trigger: 'change' }],
        listingCode: [{ required: true, message: '请输入上架代码', trigger: 'change' }]
      },
      userList: [],
      viewDialogVisible: false,
      viewData: null,
      statsDialogVisible: false,
      statsData: null,
      statsRows: [],
      statsLoading: false,
      statsForm: {
        listingCode: '',
        listingDate: '',
        phone: ''
      },
      statsPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      importLoading: false
    }
  },
  created() {
    this.loadData()
    this.loadUsers()
  },
  computed: {
    displayGroupNickname() {
      if (!this.form.userId) {
        return '请先选择所属用户'
      }
      const u = this.userList.find(x => x.id === this.form.userId)
      if (!u) return '—'
      const g = u.groupNickname
      return g && String(g).trim() ? g : '（该用户未配置群昵称，保存后将存为空）'
    }
  },
  methods: {
    async loadData() {
      this.tableLoading = true
      try {
        const params = {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        }
        const res = await getAuctionList(params)
        this.tableData = res.data.list || []
        this.pagination.total = res.data.total || 0
      } catch (e) {
        console.error(e)
      } finally {
        this.tableLoading = false
      }
    },
    async loadUsers() {
      try {
        const res = await getAuctionUsers()
        this.userList = res.data || []
      } catch (e) {
        console.error(e)
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1
      this.loadData()
    },
    handleReset() {
        this.searchForm = {
          groupNickname: '',
          cardSource: null,
          auctionMethod: null,
          listingCode: '',
          listingDate: '',
          phone: ''
        }
      this.handleSearch()
    },
    handlePageChange(val) {
      this.pagination.pageNum = val
      this.loadData()
    },
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增上拍'
      this.resetForm()
      this.dialogVisible = true
    },
    async handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑上拍'
      try {
        const res = await getAuction(row.id)
        const d = res.data
        this.form = {
          id: d.id,
          userId: d.userId,
          cardSource: d.cardSource,
          listingCode: d.listingCode || '',
          auctionMethod: d.auctionMethod,
          orderCount: d.orderCount,
          listingDate: d.listingDate,
          listingDays: d.listingDays,
          cutoffDate: d.cutoffDate,
          remark: d.remark || ''
        }
        this.dialogVisible = true
      } catch (e) {
        console.error(e)
      }
    },
    handleDialogClose() {
      this.$refs.formRef.resetFields()
      this.submitLoading = false
    },
    resetForm() {
      this.form = {
        id: null,
        userId: null,
        cardSource: 1,
        listingCode: '',
        auctionMethod: 1,
        orderCount: 1,
        listingDate: '',
        listingDays: 7,
        cutoffDate: '',
        remark: ''
      }
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.submitLoading = true
        try {
          if (this.isEdit) {
            await updateAuction(this.form.id, {
              cardSource: this.form.cardSource,
              listingCode: this.form.listingCode,
              auctionMethod: this.form.auctionMethod,
              orderCount: this.form.orderCount,
              listingDate: this.form.listingDate,
              listingDays: this.form.listingDays,
              cutoffDate: this.form.cutoffDate,
              remark: this.form.remark
            })
            this.$message.success('更新成功')
          } else {
            await addAuction({
              userId: this.form.userId,
              cardSource: this.form.cardSource,
              listingCode: this.form.listingCode,
              auctionMethod: this.form.auctionMethod,
              orderCount: this.form.orderCount,
              listingDate: this.form.listingDate,
              listingDays: this.form.listingDays,
              cutoffDate: this.form.cutoffDate,
              remark: this.form.remark
            })
            this.$message.success('新增成功')
          }
          this.dialogVisible = false
          this.loadData()
        } catch (e) {
          console.error(e)
        } finally {
          this.submitLoading = false
        }
      })
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除该上拍记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await deleteAuction(row.id)
        this.$message.success('删除成功')
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') {
          console.error(e)
        }
      }
    },
    async handleView(row) {
      try {
        const res = await getAuction(row.id)
        this.viewData = res.data
        this.viewDialogVisible = true
      } catch (e) {
        console.error(e)
      }
    },
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      return d.toLocaleString()
    },
    triggerImport() {
      this.$refs.importFileInput.value = ''
      this.$refs.importFileInput.click()
    },
    async handleFileChange(e) {
      const file = e.target.files[0]
      if (!file) return
      this.importLoading = true
      try {
        await importAuction(file)
        this.$message.success('导入成功')
        this.loadData()
      } catch (e) {
        this.$message.error(e.message || '导入失败')
      } finally {
        this.importLoading = false
      }
    },
    async handleDownloadTemplate() {
      try {
        const res = await downloadAuctionTemplate()
        const blob = res.__blob ? res.__blob.data : res
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '上拍记录导入模板.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('下载模板失败')
      }
    },
    async handleStats() {
      this.statsForm.listingCode = this.searchForm.listingCode || ''
      this.statsForm.listingDate = this.searchForm.listingDate || ''
      this.statsForm.phone = this.searchForm.phone || ''
      this.statsPagination.pageNum = 1
      this.statsDialogVisible = true
      await this.handleStatsQuery()
    },
    handleStatsDialogClose() {
      this.statsLoading = false
    },
    handleStatsReset() {
      this.statsForm.listingCode = ''
      this.statsForm.listingDate = ''
      this.statsForm.phone = ''
      this.statsRows = []
      this.statsData = null
    },
    async handleStatsQuery() {
      this.statsLoading = true
      try {
        const res = await getAuctionStats({
          listingCode: this.statsForm.listingCode || null,
          listingDate: this.statsForm.listingDate || null,
          phone: this.statsForm.phone || null,
          pageNum: this.statsPagination.pageNum,
          pageSize: this.statsPagination.pageSize
        })
        if (res.code === 200 && res.data) {
          this.statsData = res.data
          this.statsRows = res.data.rows || []
          this.statsPagination.total = res.data.total || 0
        } else {
          this.statsRows = []
          this.statsData = null
          this.statsPagination.total = 0
        }
      } catch (e) {
        this.$message.error('统计失败')
        this.statsRows = []
        this.statsData = null
        this.statsPagination.total = 0
      } finally {
        this.statsLoading = false
      }
    },
    handleStatsPageChange(val) {
      this.statsPagination.pageNum = val
      this.handleStatsQuery()
    },
  }
}
</script>

<style scoped lang="scss">
.auction-management {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.table-card {
  min-height: 500px;
}

.readonly-tip {
  color: #606266;
}

.stats-search {
  margin-bottom: 12px;
}

.stats-summary {
  margin-bottom: 4px;
}

.stats-totals {
  margin-top: 8px;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
}
</style>
